<template>
    <span class="jom-refer-table" v-if="data.type == 'table'" :name="data.rid" @click="scrollTo(data.rid)">
      <component :is="'jo' + item.name" v-for="item in data.data" v-bind:key="item.index" v-bind:data="item.data"></component>
    </span>
    <span class="jom-refer-fig" v-else-if="data.type == 'fig' || data.type == 'chem'" :name="data.rid" @click="scrollTo(data.rid)">
      <component :is="'jo' + item.name" v-for="item in data.data" v-bind:key="item.index" v-bind:data="item.data"></component>
    </span>
    <span class="jom-refer-table" v-else-if="data.type == 'disp-formula'" :name="data.rid" @click="scrollTo(data.rid)">
      <component :is="'jo' + item.name" v-for="item in data.data" v-bind:key="item.index"
                 v-bind:data="item.data"></component>
    </span>
</template>
<script>
export default {
    data(){
        return {

        }
    },
    props:[
        "data",
    ],
    methods:{
        scrollTo(id){
          var top=$("#"+id).offset().top;
          if (this.layout === 'rc') {
            top-=55;
          } else {
            top-=5;
          }
            $(window).scrollTop(top);
        }
    }
}
</script>
<style lang="scss" scoped>
    .jom-refer-table,.jom-refer-fig {
        color: #00a2af;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/componentsMobile/maincontent/body/common/anchor.vue